import { DepartmentParams } from './types';

export const departmentKeys = {
  managed: (params?: DepartmentParams) =>
    ['MANAGED_DEPARTMENTS', params] as const,
};
